import { render, staticRenderFns } from "./dealDoc.vue?vue&type=template&id=9c24118a&scoped=true"
import script from "./dealDoc.vue?vue&type=script&lang=js"
export * from "./dealDoc.vue?vue&type=script&lang=js"
import style0 from "./dealDoc.vue?vue&type=style&index=0&id=9c24118a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c24118a",
  null
  
)

export default component.exports